import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Grid2 as Grid } from '@mui/material';

function ButtonLoadMore({ onClick, isAtEndOfList, isFetching, paging, variant = 'outlined' }: any) {
  if (isAtEndOfList) {
    return null;
  }

  if (paging && paging.page && paging.page >= paging.total_pages) {
    return null;
  }

  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid>
        <Button variant={variant} color="primary" onClick={onClick} disabled={isFetching}>
          {isFetching ? (
            <FormattedMessage id="LOADING_MORE" />
          ) : (
            <FormattedMessage id="LOAD_MORE" />
          )}
        </Button>
      </Grid>
    </Grid>
  );
}

export default ButtonLoadMore;
